module.exports = __webpack_public_path__ + "media/fonts/glyphicons-halflings-regular-7ad17c60.eot";